import { createAction, handleActions } from 'redux-actions';
import {
  api_succession_talent_pool,
  api_succession_talent_pool_changelog,
  api_succession_talent_pool_members,
} from 'constants/apiRoutes';
import {
  SUCCESSION_POOL_MEMBERS_DEFAULT_PARAMS,
  SUCCESSION_POOL_CHANGELOG_DEFAULT_PARAMS,
} from 'constants/pages';
import http from 'utility/http';

// ------------------------------------
// Constants
// ------------------------------------

const SET_SUCCESSION_POOL = 'SET_SUCCESSION_POOL';
const SET_SUCCESSION_POOL_MEMBERS = 'SET_SUCCESSION_POOL_MEMBERS';
const SET_SUCCESSION_POOL_CHANGELOG = 'SET_SUCCESSION_POOL_CHANGELOG';
const LOAD_MORE_SUCCESSION_POOL_MEMBERS = 'LOAD_MORE_SUCCESSION_POOL_MEMBERS';
const LOAD_MORE_SUCCESSION_POOL_CHANGELOG =
  'LOAD_MORE_SUCCESSION_POOL_CHANGELOG';

// ------------------------------------
// Initial state
// ------------------------------------

const initialState = {
  pool: null,
  members: {},
  changelog: {},
};

// ------------------------------------
// Actions
// ------------------------------------

export const setSuccessionPool = createAction(SET_SUCCESSION_POOL);
export const setSuccessionPoolMembers = createAction(
  SET_SUCCESSION_POOL_MEMBERS
);
export const setSuccessionPoolChangelog = createAction(
  SET_SUCCESSION_POOL_CHANGELOG
);
const loadMoreSuccessionPoolMembers = createAction(
  LOAD_MORE_SUCCESSION_POOL_MEMBERS
);
const loadMoreSuccessionPoolChangelog = createAction(
  LOAD_MORE_SUCCESSION_POOL_CHANGELOG
);

// ------------------------------------
// Reducers
// ------------------------------------

const reducers = {
  [SET_SUCCESSION_POOL]: (state, { payload }) => ({
    ...state,
    pool: payload,
  }),
  [SET_SUCCESSION_POOL_MEMBERS]: (state, { payload }) => ({
    ...state,
    members: payload || {},
  }),
  [LOAD_MORE_SUCCESSION_POOL_MEMBERS]: (state, { payload }) => ({
    ...state,
    members: {
      ...payload,
      results: state.members.results
        ? [...state.members.results, ...(payload.results || [])]
        : [...(payload.results || [])],
    },
  }),
  [SET_SUCCESSION_POOL_CHANGELOG]: (state, { payload }) => ({
    ...state,
    changelog: payload || {},
  }),
  [LOAD_MORE_SUCCESSION_POOL_CHANGELOG]: (state, { payload }) => ({
    ...state,
    changelog: {
      ...payload,
      results: state.changelog.results
        ? [...state.changelog.results, ...(payload.results || [])]
        : [...(payload.results || [])],
    },
  }),
};

// ------------------------------------
// API calls
// ------------------------------------

export const getSuccessionPool = (dispatch, poolId) =>
  http.get(api_succession_talent_pool(poolId)).then(({ data }) => {
    dispatch(setSuccessionPool(data));
    return data;
  });

export const getSuccessionPoolMembers = (
  dispatch,
  poolId,
  params = {},
  isLoadMore = false
) =>
  http
    .get(api_succession_talent_pool_members(poolId), {
      params: {
        ...SUCCESSION_POOL_MEMBERS_DEFAULT_PARAMS,
        ...params,
      },
    })
    .then(({ data }) => {
      dispatch(
        isLoadMore
          ? loadMoreSuccessionPoolMembers(data)
          : setSuccessionPoolMembers(data)
      );
      return data;
    });

export const getSuccessionPoolChangelog = (
  dispatch,
  poolId,
  isLoadMore = false,
  params = {}
) =>
  http
    .get(api_succession_talent_pool_changelog(poolId), {
      params: {
        ...SUCCESSION_POOL_CHANGELOG_DEFAULT_PARAMS,
        ...params,
      },
    })
    .then(({ data }) => {
      dispatch(
        isLoadMore
          ? loadMoreSuccessionPoolChangelog(data)
          : setSuccessionPoolChangelog(data)
      );
      return data;
    });

export default handleActions(reducers, initialState);

// ------------------------------------
// "plain" action functions
// ------------------------------------

export const clearSuccessionPool = dispatch => {
  dispatch(setSuccessionPool(initialState.pool));
  dispatch(setSuccessionPoolMembers(initialState.members));
  dispatch(setSuccessionPoolChangelog(initialState.changelog));
};
